import * as yup from "yup";

export const merchantPriceValidationSchema = yup.object({
  value: yup
    .number()
    .typeError("Price should be positive integer number")
    .required("Merchant price is required")
    .moreThan(0, "Price should be positive integer number")
    .integer("Price should be positive integer number")
});
